export default "__VITE_ASSET__8ce27a0e__"